/**
 * Produktgalerie: Inline-Videos starten beim Sichtbarwerden (Mobile/Desktop).
 * Blockiert Lightbox-Modal für Video-Slides.
 */
(function () {
  const GALLERY = 'media-gallery';
  const VIDEO_WRAP = '.product__inline-autoplay-video';

  function prepareVideo(video) {
    if (!video || video.dataset.rfPrepared === 'true') return;
    video.dataset.rfPrepared = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    video.disablePictureInPicture = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('controls');
    video.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
  }

  function playVideo(video) {
    if (!video) return;
    prepareVideo(video);
    const attempt = () => {
      const promise = video.play();
      if (promise?.catch) promise.catch(() => {});
    };
    if (video.readyState >= 2) attempt();
    else {
      video.addEventListener('loadeddata', attempt, { once: true });
      video.addEventListener('canplay', attempt, { once: true });
    }
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    try {
      video.pause();
    } catch (e) {
      /* ignore */
    }
  }

  function blockVideoModal() {
    document.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('.product-media-container--inline-video')) {
          const isNativeControl = event.target.closest('video, iframe');
          if (!isNativeControl) {
            event.preventDefault();
            event.stopPropagation();
          }
        }

        const legacyOpener = event.target.closest(
          '.product__modal-opener--video, .product__modal-opener--external_video'
        );
        if (legacyOpener) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.rfVideoInit === 'true') return;
    gallery.dataset.rfVideoInit = 'true';

    const wraps = gallery.querySelectorAll(VIDEO_WRAP);
    if (!wraps.length) return;

    const syncVisible = () => {
      wraps.forEach((wrap) => {
        const video = wrap.querySelector('video');
        if (!video) return;

        const slide = wrap.closest('.product__media-item');
        const rect = (slide || wrap).getBoundingClientRect();
        const visible = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
        const ratio = visible / Math.max((slide || wrap).offsetWidth, 1);

        if (ratio >= 0.45) playVideo(video);
        else pauseVideo(video);
      });
    };

    requestAnimationFrame(syncVisible);
    window.setTimeout(syncVisible, 150);
    window.setTimeout(syncVisible, 500);
    window.addEventListener('load', syncVisible, { once: true });
    window.addEventListener('pageshow', syncVisible);

    const slider = gallery.querySelector('[id^="Slider-"]');
    if (slider) {
      slider.addEventListener('scroll', () => window.requestAnimationFrame(syncVisible), { passive: true });
    }
  }

  function initMetafieldVideos() {
    document.querySelectorAll('.product__rf-metafield video').forEach((video) => {
      prepareVideo(video);
      if (!video.hasAttribute('loop')) video.loop = true;
      playVideo(video);
    });
  }

  function init(scope) {
    const root = scope?.nodeType === 1 ? scope : document;
    root.querySelectorAll(GALLERY).forEach(initGallery);
    initMetafieldVideos();
  }

  blockVideoModal();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
